import {Component, input} from '@angular/core';
import {InsightType} from '../models/insight-type.model';
import {SvgSpriteIcon} from '@selpia/shared/ui';

@Component({
  selector: 'lib-insight-tag',
  templateUrl: './insight-tag.component.html',
  styleUrl: './insight-tag.component.scss',
})
export class InsightTagComponent {
  insightType = input.required<InsightType>();
  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
